import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ManageDeliveryService {
  public lastPageUrl;
  constructor(private httpClient: HttpClient) {}

  // ** Start Refactoring **

  getJobRequest(id, params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/' + id, { params })
      .toPromise();
  }

  getJobRequests(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests', { params })
      .toPromise();
  }

  getBusinessReturnsJobRequests(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/businesses/returns', {
        params,
      })
      .toPromise();
  }

  getBusinessRelanceJobRequests(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/businesses/relance', {
        params,
      })
      .toPromise();
  }

  getJobRequestsByCentrale(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/inventories/centrale', {
        params,
      })
      .toPromise();
  }

  getPickUpJobRequests(params): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/jobrequests/pickups', { params })
      .toPromise();
  }

  getBusinessesLocations(params): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/businesses/locations', {
        params,
      })
      .toPromise();
  }

  getPickupsLocations(params): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/jobrequests/pickups/locations', {
        params,
      })
      .toPromise();
  }

  getNoRecentPickups(params): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/jobrequests/pickups/no-recent', {
        params,
      })
      .toPromise();
  }

  getPickUpsGroupedByBusiness(params): any {
    return this.httpClient
      .get(
        environment.api.serverUrl +
          '/jobrequests/pickups/grouped-by-businesses/xlsx',
        {
          params,
          responseType: 'blob',
        }
      )
      .toPromise();
  }

  async getAllDriversNames(service = undefined): Promise<any> {
    try {
      const drivers = (await this.httpClient
        .get(environment.api.user + '/drivers/names')
        .toPromise()) as any[];

      return drivers.sort((a: any, b: any) => a.name?.localeCompare(b.name));
    } catch (error) {
      console.error('Error fetching drivers:', error);
      throw error;
    }
  }

  getDriversNamesByCentrale(service = undefined): any {
    return this.httpClient
      .get(environment.api.user + '/drivers/names/belong-to-my-centrale')
      .toPromise();
  }

  getBusinesses(params): any {
    return this.httpClient
      .get(environment.api.user + '/businesses/names', { params })
      .toPromise();
  }

  getAllBusinessesNames(service = undefined): any {
    return this.httpClient
      .get(environment.api.user + '/businesses/names')
      .toPromise()
      .then((response: any[]) => {
        return response.sort((a, b) => {
          const nameA = a.nomCommercial || '';
          const nameB = b.nomCommercial || '';
          return nameA.localeCompare(nameB);
        });
      });
  }

  getAllAdminsNames(): any {
    return this.httpClient
      .get(environment.api.user + '/admins/names')
      .toPromise()
      .then((response: any[]) => {
        return response.sort((a, b) => a.name.localeCompare(b.name));
      });
  }

  async getAllCentralesNames(params = {}): Promise<any> {
    try {
      const centrales = (await this.httpClient
        .get(environment.api.user + '/centrales/names', { params })
        .toPromise()) as any[];

      return centrales.sort((a: any, b: any) => a.name.localeCompare(b.name));
    } catch (error) {
      console.error('Error fetching centrales:', error);
      throw error;
    }
  }

  getMyCentralesNames(params = {}): any {
    return this.httpClient
      .get(environment.api.user + '/centrales/mine/names', { params })
      .toPromise();
  }

  generateDriverHTMLPDF(params): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/runsheets/pdf', params, {
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .toPromise();
  }

  generateReturnSheetPDF({ ids }): any {
    return this.httpClient
      .post(
        environment.api.serverUrl + '/runsheets/pdf/return-runsheet',
        { ids },
        {
          observe: 'response',
          responseType: 'arraybuffer',
        }
      )
      .toPromise();
  }

  assignDeliveriesToDriver(deliveryRequests): any {
    return this.httpClient
      .post(
        environment.api.backendBase + '/jobrequests/assign',
        deliveryRequests
      )
      .toPromise();
  }

  exportJobRequestsToExcel(query): any {
    return this.httpClient
      .post(environment.api.backendBase + '/jobrequests/xlsx', query, {
        observe: 'response',
        responseType: 'blob',
      })
      .toPromise();
  }

  updateDeliveryJobStatus(id, status): any {
    return this.httpClient
      .put(environment.api.backendBase + `/jobrequests/${id}/status/`, {
        status,
      })
      .toPromise();
  }

  updateDeliveryRequestDriver(id, driver = undefined): any {
    return this.httpClient
      .put(environment.api.backendBase + `/jobrequests/${id}`, { driver })
      .toPromise();
  }

  editPickupRequest(id, deliveryRequest): any {
    return this.httpClient
      .put(
        environment.api.backendBase + `/jobrequests/pickups/${id}`,
        deliveryRequest
      )
      .toPromise();
  }

  editDeliveryRequest(id, deliveryRequest): any {
    return this.httpClient
      .put(environment.api.backendBase + `/jobrequests/${id}`, deliveryRequest)
      .toPromise();
  }

  editDeliveryRequestSize(nid, query): any {
    return this.httpClient
      .put(environment.api.backendBase + `/jobrequests/${nid}/size`, query)
      .toPromise();
  }

  editDeliveryRequestsSize(query): any {
    return this.httpClient
      .put(environment.api.backendBase + `/jobrequests/size`, query)
      .toPromise();
  }

  getAllJobRequestsGroups(params): any {
    return this.httpClient
      .get(environment.api.backendBase + `/jobrequests-groups`, { params })
      .toPromise();
  }

  getRunSheets(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/runsheets', { params })
      .toPromise();
  }

  getRunSheetsDetails(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/runsheets/details', { params })
      .toPromise();
  }

  updateRunsheetStatus(body): any {
    return this.httpClient
      .put(environment.api.backendBase + '/runsheets/status', body)
      .toPromise();
  }

  getDespositRetardJobRequests(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/retard/desposit', {
        params,
      })
      .toPromise();
  }

  getDeliveryRetardJobRequests(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/retard/delivery', {
        params,
      })
      .toPromise();
  }

  getPickUpsByBusiness(params): any {
    return this.httpClient.get(
      environment.api.backendBase +
        '/jobrequests/pickups/grouped-by-businesses',
      {
        params,
      }
    );
  }

  getTransfersCentral(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/transfers-central', { params })
      .toPromise();
  }

  generateTransferPDF(query): any {
    return this.httpClient
      .post(
        environment.api.backendBase + '/transfers-central/runsheet/pickup/pdf',
        query,
        {
          observe: 'response',
          responseType: 'arraybuffer',
        }
      )
      .toPromise();
  }

  getJobByPackingSlip(params): any {
    return this.httpClient.get(
      environment.api.backendBase + '/jobrequests/jobrequest/by-packing-slip',
      { params }
    );
  }

  createTransfertCentrale(payload): any {
    return this.httpClient
      .post(environment.api.backendBase + '/transfers-central', payload)
      .toPromise();
  }

  createTransferCentralExchange(payload): any {
    return this.httpClient
      .post(
        environment.api.backendBase + '/transfers-central/exchanges',
        payload
      )
      .toPromise();
  }

  scanEntreeCentrale(body): any {
    return this.httpClient.post(
      environment.api.backendBase + '/jobrequests/scans/enter-central',
      body
    );
  }

  scanPermanentReturn(payload): any {
    return this.httpClient.post(
      environment.api.backendBase + '/jobrequests/scans/permanent-return',
      payload
    );
  }

  exchangeReturnedToClient(deliveryRequests): any {
    return this.httpClient
      .post(
        environment.api.backendBase +
          '/jobrequests/scans/return-exchange-to-business',
        deliveryRequests
      )
      .toPromise();
  }

  exchangesReturnedToClient(deliveryRequests): any {
    return this.httpClient
      .post(
        environment.api.backendBase +
          '/jobrequests/scans/return-exchanges-to-business',
        deliveryRequests
      )
      .toPromise();
  }

  resetJobRequestsWithScan(body): any {
    return this.httpClient.post(
      environment.api.backendBase + '/jobrequests/scans/reset',
      body
    );
  }

  relanceJobRequest(body): any {
    return this.httpClient.post(
      environment.api.backendBase + '/jobrequests/scans/relance',
      body
    );
  }

  setResetVerificationJobRequest(body): any {
    return this.httpClient.post(
      environment.api.backendBase + '/jobrequests/scans/verify',
      body
    );
  }

  setVerificationJobRequest(body): any {
    return this.httpClient.post(
      environment.api.backendBase + '/jobrequests/scans/verification',
      body
    );
  }

  scanRetourVendeur(body): any {
    return this.httpClient.post(
      environment.api.backendBase + '/jobrequests/scans/return-to-seller',
      body
    );
  }

  scanRetourVendeurDone(body): any {
    return this.httpClient.post(
      environment.api.backendBase +
        '/jobrequests/scans/return-to-seller-confirmed',
      body
    );
  }

  scanRetourVendeurExchange(body): any {
    return this.httpClient.post(
      environment.api.backendBase +
        '/jobrequests/scans/return-exchange-to-seller',
      body
    );
  }

  // getNonPersistantCentralTransfer(params = {}): any {
  //   return this.httpClient
  //     .get(
  //       environment.api.backendBase +
  //         '/transfers-central/no-persistant-central-transfer',
  //       { params }
  //     )
  //     .toPromise();
  // }

  getNonPersistantCentralTransfer(params = {}): any {
    return new Promise((resolve) => {
      resolve([]);
    });
  }

  saveToNonPersistantCentralTransfer(body): any {
    return this.httpClient
      .post(
        environment.api.backendBase +
          '/transfers-central/no-persistant-central-transfer',
        body
      )
      .toPromise();
  }

  deleteFromNonPersistantCentralTransfer(body): any {
    return this.httpClient
      .put(
        environment.api.backendBase +
          '/transfers-central/no-persistant-central-transfer',
        body
      )
      .toPromise();
  }

  getPackageRequests(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/package-requests', { params })
      .toPromise();
  }

  treatPackageRequests(queries): any {
    return this.httpClient
      .put(environment.api.backendBase + '/package-requests', queries)
      .toPromise();
  }

  createNewPackageRequest(obj): any {
    return this.httpClient
      .post(environment.api.backendBase + '/package-requests', obj)
      .toPromise();
  }

  getLostBusinesses(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/businesses/lost', {
        params,
      })
      .toPromise();
  }

  getLostBusinessesExcel(body = {}): any {
    return this.httpClient
      .post(
        environment.api.backendBase + '/jobrequests/businesses/lost',
        body,
        {
          observe: 'response',
          responseType: 'blob',
        }
      )
      .toPromise();
  }

  getRunsheetsPerformance(page, limit = 20, payload): any {
    return this.httpClient
      .get(
        environment.api.serverUrl +
          `/runsheets/performance?limit=${limit}&page=${page}`,
        {
          params: payload,
        }
      )
      .toPromise();
  }

  confirmReturnFromRunsheet(payload): any {
    return this.httpClient
      .post(
        environment.api.serverUrl + `/runsheets/confirm-return-from-runsheet`,
        payload
      )
      .toPromise();
  }

  confirmeExchange(id): any {
    return this.httpClient
      .post(
        environment.api.backendBase + `/jobrequests/${id}/confirme-exchange`,
        {}
      )
      .toPromise();
  }

  assignPickUpRequests(payload): any {
    return this.httpClient
      .post(
        environment.api.backendBase + '/jobrequests/pickups/assign',
        payload
      )
      .toPromise();
  }

  assignBusinessPickUpRequests(payload): any {
    return this.httpClient
      .post(
        environment.api.backendBase + '/jobrequests/pickups/business/assign',
        payload
      )
      .toPromise();
  }

  geBusinessPickupsPeriodic(params): any {
    return this.httpClient
      .get(
        environment.api.backendBase + '/jobrequests/businesses/compare-periods',
        {
          params,
        }
      )
      .toPromise();
  }

  getSortedDrivers(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/drivers/sorted', {
        params,
      })
      .toPromise();
  }

  getSortedDriversXls(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/drivers/sorted', {
        params,
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .toPromise();
  }

  jobRequestsNotFound(payload): any {
    return this.httpClient
      .put(environment.api.backendBase + `/jobrequests/not-found`, payload)
      .toPromise();
  }

  getInventories(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/inventories', {
        params,
      })
      .toPromise();
  }

  getJobRequestsInventoryByCentrale(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/inventories/centrale', {
        params,
      })
      .toPromise();
  }

  saveCentraleInventory(payload): any {
    return this.httpClient
      .post(
        environment.api.backendBase + `/jobrequests/inventories/centrale`,
        payload
      )
      .toPromise();
  }

  // ** End Refactoring **

  updateStatus(body): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/runsheet/updatestatus', body)
      .toPromise();
  }

  updateStatusV2(body): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/runsheet/update-status', body)
      .toPromise();
  }

  getAllDeliveryRequest(query, populate, page): any {
    var skip = (page - 1) * 10;
    var limit = 10;
    return this.httpClient
      .get(
        environment.api.deliveryRequest +
          '?sort=-createdAt&query=' +
          JSON.stringify(query) +
          '&populate=' +
          JSON.stringify(populate) +
          '&skip=' +
          skip +
          '&limit=' +
          limit,
        { observe: 'response' }
      )
      .toPromise();
  }
  getCentralTransfer(body): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/centrale/filtertransfer', body)
      .toPromise();
  }

  adjustTransferGroups(body): any {
    return this.httpClient
      .post(
        environment.api.serverUrl + '/centrale/adjustTodayTransferGroupes',
        body
      )
      .toPromise();
  }
  deletePackageFromTransfert(body): any {
    return this.httpClient
      .post(
        environment.api.serverUrl + '/centrale/deletePackageFromTransfert',
        body
      )
      .toPromise();
  }

  lastDriversPositions(params): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/drivers/last-drivers-positions', {
        params,
      })
      .toPromise();
  }

  generatePickUpPdf(ids): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/generatepickuppdf', ids)
      .toPromise();
  }
  generatePickUpSheet(query): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/generatePickUpSheet', query, {
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .toPromise();
  }
  generateEtatJournalPDF(query): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/generateEtatJournal', query, {
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .toPromise();
  }

  generateEtatJournalXLS(query): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/generateEtatJournalExcel', query, {
        responseType: 'arraybuffer',
      })
      .toPromise();
  }
  filterDeliveryRequestV1(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/filter', query)
      .toPromise();
  }

  addDeliveryRequest(deliveryRequest): any {
    return this.httpClient
      .post(environment.api.deliveryRequest, deliveryRequest)
      .toPromise();
  }
  getStatsForAdmin(body): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/stats/admin', body)
      .toPromise();
  }

  editPickUpJob(deliveryRequest): any {
    return this.httpClient
      .put(environment.api.deliveryRequest, deliveryRequest)
      .toPromise();
  }
  editLivraisonJob(deliveryRequest): any {
    return this.httpClient
      .put(environment.api.deliveryRequest + '/livraison', deliveryRequest)
      .toPromise();
  }

  filterDeliveryRequest(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/filter/v2', query)
      .toPromise();
  }
  confirmReceptionOfOldPackage(query): any {
    return this.httpClient
      .post(
        environment.api.deliveryRequest + '/confirmReceptionOfOldPackage',
        query
      )
      .toPromise();
  }
  editParcelSize(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/editParcelSize', query)
      .toPromise();
  }

  filterDeliveryRequestV5(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/filter/v5', query)
      .toPromise();
  }
  getUrgentPackages(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/getSpecialPackages', query)
      .toPromise();
  }
  setSpecialPackage(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/setPackageToSpecial', query)
      .toPromise();
  }
  filterDeliveryRequestv3(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/filter/v3', query)
      .toPromise();
  }
  getHowMuchMoneyIOweIntigo(businessId): any {
    return this.httpClient
      .get(
        environment.api.serverUrl +
          '/deliveryrequest/partnerMoney/' +
          businessId
      )
      .toPromise();
  }
  receivingMoneyFromDriver(query): any {
    return this.httpClient
      .post(
        environment.api.deliveryRequest + '/receivingMoneyFromDriver',
        query
      )
      .toPromise();
  }
  editGivingMoneyToClientByGroup(query): any {
    return this.httpClient
      .post(
        environment.api.deliveryRequest + '/sendingMoneyToClientbygroup',
        query
      )
      .toPromise();
  }
  editGivingMoneyToClient(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/sendingMoneyToClient', query)
      .toPromise();
  }

  getAvailableDriver4Delivery(): any {
    return this.httpClient.get(environment.api.user + '/drivers').toPromise();
  }

  assignDriver2Delivery(deliveryRequests): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/assign', deliveryRequests)
      .toPromise();
  }
  assignDriver2CentraleTransfert(deliveryRequests): any {
    return this.httpClient
      .post(environment.api.centrale + '/createtransfer', deliveryRequests)
      .toPromise();
  }

  assignDriver2TransfertRetour(deliveryRequests): any {
    return this.httpClient
      .post(environment.api.centrale + '/transferretour', deliveryRequests)
      .toPromise();
  }

  saveToNonPersistantGroup(body): any {
    return this.httpClient
      .post(
        environment.api.centrale + '/saveToNonPersistantCentralTransfer',
        body
      )
      .toPromise();
  }
  getNonPersistantData(body = {}): any {
    return this.httpClient
      .post(environment.api.centrale + '/centralTransfer/nonPersistant', body)
      .toPromise();
  }

  getAllTheDeliveryRequest(query, populate, page, itemsPerPage = 10): any {
    var skip = (page - 1) * itemsPerPage;
    var limit = itemsPerPage;
    return this.httpClient
      .get(
        environment.api.deliveryRequest +
          '?sort=-createdAt' +
          '&populate=' +
          populate +
          '&query=' +
          query +
          '&skip=' +
          skip +
          '&limit=' +
          limit,
        { observe: 'response' }
      )
      .toPromise();
  }

  getAllThePickUps(query, populate, page, itemsPerPage = 10): any {
    var skip = (page - 1) * itemsPerPage;
    var limit = itemsPerPage;
    return this.httpClient
      .post(environment.api.serverUrl + '/packingSlip/v2', query)
      .toPromise();
  }

  getAllTheDeliveryJobGroups(query, populate, page, itemsPerPage = 10): any {
    var skip = (page - 1) * itemsPerPage;
    var limit = itemsPerPage;
    return this.httpClient
      .get(
        environment.api.serverUrl +
          '/JobRequestsGroup?sort=-createdAt' +
          '&populate=' +
          populate +
          '&query=' +
          query +
          '&skip=' +
          skip +
          '&limit=' +
          limit,
        { observe: 'response' }
      )
      .toPromise();
  }
  getPickUpsBySupplier(query): any {
    return this.httpClient
      .post(environment.api.business + '/getMultiplePickUpsPoint', query)
      .toPromise();
  }

  getDeliveriesPerDriver(query): any {
    return this.httpClient
      .post(environment.api.driver + '/driverDelays', query)
      .toPromise();
  }

  getAllTheDeliveryRequestHistory(
    query,
    populate,
    page,
    itemsPerPage = 10
  ): any {
    var skip = (page - 1) * itemsPerPage;
    var limit = itemsPerPage;
    return this.httpClient
      .get(
        environment.api.jobRequestHistory +
          '?sort=-date' +
          '&populate=' +
          populate +
          '&query=' +
          query +
          '&skip=' +
          skip +
          '&limit=' +
          limit,
        { observe: 'response' }
      )
      .toPromise();
  }

  getAllTheDeliveryRequestHistoryV2(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/history/filter', query)
      .toPromise();
  }

  filterAllTheDeliveryRequest(query): any {
    return this.httpClient
      .post(environment.api.deliveryRequest + '/filter/v2', query)
      .toPromise();
  }
  getJobByNid(body): any {
    return this.httpClient
      .post(environment.api.packingSlip + '/JobByNid', body)
      .toPromise();
  }

  scanEntreeCentraleInGroup(body): any {
    return this.httpClient
      .post(environment.api.packingSlip + '/scanEntreeCentraleInGroup', body)
      .toPromise();
  }

  scanRetourDefinitif(body): any {
    return this.httpClient
      .post(environment.api.packingSlip + '/scanDefinitif', body)
      .toPromise();
  }

  askUpdateDropOffAddress(data): any {
    return this.httpClient
      .get(
        environment.api.deliveryRequest + '/askupdatedropoffaddress/' + data,
        { observe: 'response' }
      )
      .toPromise();
  }

  getAllTheClients(): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/business')
      .toPromise();
  }

  resetandResendRequest(id, body): any {
    return this.httpClient
      .put(environment.api.deliveryRequest + '/updateStatus/' + id, body)
      .toPromise();
  }

  getpackingSlip(query): any {
    return this.httpClient
      .get(environment.api.packingSlip + '?sort=-updatedAt&query=' + query)
      .toPromise();
  }

  getallUsers(userType, reqBody): any {
    return this.httpClient
      .post(environment.api.user + '/filter/users/' + userType, reqBody)
      .toPromise();
  }

  confirmRetourDef(reqBody): any {
    return this.httpClient
      .post(
        environment.api.serverUrl + '/suivi/confirmRetourDefinitif',
        reqBody
      )
      .toPromise();
  }

  getRunSheetsHistorique(reqBody): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/runsheet/saved', reqBody)
      .toPromise();
  }
  getRunSheetsCalls(reqBody): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/suivi/runsheets/calls', reqBody)
      .toPromise();
  }
  getRunSheetsTransfer(reqBody): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/suivi/transfer/runsheets', reqBody)
      .toPromise();
  }
  getsavedRunSheetsDetails(reqBody): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/runsheet/savedById', reqBody)
      .toPromise();
  }
  getRunSheetsTransferDetails(reqBody): any {
    return this.httpClient
      .post(
        environment.api.serverUrl + '/suivi/runsheetsTransferDetails',
        reqBody
      )
      .toPromise();
  }
  editParcelCentral(reqBody): any {
    return this.httpClient
      .post(
        environment.api.serverUrl +
          '/suivi/runsheetsTransferDetails/editCentral',
        reqBody
      )
      .toPromise();
  }
  editExternalBarCode(reqBody): any {
    return this.httpClient
      .post(
        environment.api.serverUrl +
          '/suivi/runsheetsTransferDetails/editExternalBarCode',
        reqBody
      )
      .toPromise();
  }
  takeDecision4runsheetItems(reqBody): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/suivi/runsheets/decision', reqBody)
      .toPromise();
  }
  confirmedReturnFromRunsheet(reqBody): any {
    return this.httpClient
      .post(
        environment.api.serverUrl +
          '/suivi/runsheets/confirmedReturnFromRunsheet',
        reqBody
      )
      .toPromise();
  }
  deleteFromNonPersistant(body): any {
    return this.httpClient
      .put(environment.api.centrale + '/deleteJobFromNonPersistant', body)
      .toPromise();
  }

  getDriversPerformanceByDateRange(obj, responseType): any {
    return this.httpClient
      .post(
        environment.api.backendBase +
          '/driverStats/deliverTimePerDriver/dateRange',
        obj,
        {
          responseType,
        }
      )
      .toPromise();
  }

  getRunsheets(page, limit = 20, payload): any {
    // With performance
    return this.httpClient
      .get(
        environment.api.serverUrl + `/runsheets?limit=${limit}&page=${page}`,
        {
          params: payload,
        }
      )
      .toPromise();
  }

  getReturnedDeliveries(runsheetId): any {
    return this.httpClient
      .get(
        environment.api.serverUrl +
          `/runsheets/returned-deliveries/${runsheetId}`
      )
      .toPromise();
  }

  getExcelRunsheets(payload): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/runsheets/performance/xls', {
        params: payload,
        responseType: 'blob',
      })
      .toPromise();
  }

  sendXlsxToSlack(payload): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/runsheets/performance-slack', {
        params: payload,
        responseType: 'json',
      })
      .toPromise();
  }

  closeRunsheet(payload): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/runsheets/close', payload)
      .toPromise();
  }

  closeAllRunsheets(payload): any {
    return this.httpClient
      .post(environment.api.serverUrl + '/runsheets/close', payload)
      .toPromise();
  }

  cleanupRunsheet(payload): any {
    return this.httpClient.post(
      environment.api.serverUrl + '/runsheets/cleanup-duplciate-items',
      payload
    );
  }
}
